import { ObchodniPodminkyPage } from "@/features/hca-public";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { usePageMeta } from "@/shared/seo/use-page-meta";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/obchodni-podminky")({
  component: ObchodniPodminkyRoute,
});

function ObchodniPodminkyRoute() {
  usePageMeta({
    title: "Obchodní podmínky",
    description: "Všeobecné obchodní podmínky vzdělávacích služeb HCA Moravia.",
    path: "/obchodni-podminky",
  });
  return (
    <PublicShellWithDiagnoza>
      <ObchodniPodminkyPage />
    </PublicShellWithDiagnoza>
  );
}
